import { GET_VFO_PERFORMANCE_REPORT } from '../../../Types'

const VfoPerformanceReportReducer = (state = [], action) => {
    switch (action.type) {
        case GET_VFO_PERFORMANCE_REPORT:
            return action.payload
        default:
            return state
    }
}
export default VfoPerformanceReportReducer